import {Injectable} from '@angular/core';
import {CaseEntityDto} from "@esa/api/models/CaseEntityDto";
import {CaseEntitiesActions} from "../store/actions";
import {CaseStatusEnum} from "@esa/api";
import {Store} from "@ngrx/store";
import {TranslateService} from "@ngx-translate/core";
import {CaseEntityWithCategory} from "../models/case-category";
import {CaseEntityWithRequestType} from "../models/case-request-type";

@Injectable({
  providedIn: 'root'
})
export class CaseStatusService {
  constructor(private _store: Store, private translateService: TranslateService) { }

  archiveCase(caseEntity: CaseEntityDto) {
    this.updateCaseEntity(caseEntity, CaseStatusEnum.ARCHIVED);
  }

  saveCaseAsDraft(caseEntity: CaseEntityDto) {
    this.updateCaseEntity(caseEntity, CaseStatusEnum.DRAFT);
  }

  approveCase(caseEntity: CaseEntityDto) {
    if(caseEntity.caseStatus == CaseStatusEnum.DRAFT) {
      this.updateCaseEntity(caseEntity, CaseStatusEnum.NEW);
    } else if(caseEntity.caseStatus == CaseStatusEnum.NEW) {
      this.updateCaseEntity(caseEntity, CaseStatusEnum.APPROVED);
    } else if (caseEntity.caseStatus == CaseStatusEnum.COMPLETED) {
      this.updateCaseEntity(caseEntity, CaseStatusEnum.CLOSED);
    }
  }

  rejectCase(caseEntity: CaseEntityDto) {
    this.updateCaseEntity(caseEntity, CaseStatusEnum.REJECTED);
  }

  updateCaseEntity(caseEntity: CaseEntityDto, caseStatus: CaseStatusEnum) {
    const categorizedCase = caseEntity as CaseEntityWithCategory;
    const prioritizedCase = caseEntity as CaseEntityWithRequestType;
    let caseId = (caseEntity as any).caseId;
    caseId = caseId ? caseId : caseEntity.id;

    this._store.dispatch(CaseEntitiesActions.updateCaseEntity({
      caseEntity: {
        id: caseId,
        caseTitle: caseEntity.caseTitle,
        caseCategoryId: categorizedCase.caseCategoryId,
        caseRequestTypeId: prioritizedCase.caseRequestTypeId,
        casePriority: caseEntity.casePriority,
        caseStatus: caseStatus,
        createdByUserId: caseEntity.createdByUserId,
        originatingFiuId: caseEntity.originatingFiuId,
        assignedUserId: caseEntity.assignedUserId,
        assignedFIUId: caseEntity.assignedFIUId,
        caseDescription: caseEntity.caseDescription,
        caseSubjects: caseEntity.caseSubjects,
        caseDetails: caseEntity.caseDetails,
        deadLine: caseEntity.deadLine
      }
    }));
  }

  checkSystemStatus(userFiuId: string, originatingFIU: string, assignedFIU: string, currentStatus: string, truncate?: boolean): string {
    let originatingState: string = '';
    let assignedState: string = '';

    if (userFiuId === originatingFIU) {
      switch (currentStatus) {
        case CaseStatusEnum.DRAFT:
          originatingState = CaseStatusEnum.DRAFT;
          break;
        case CaseStatusEnum.NEW:
          originatingState = this.translateService.instant('caseManagement.caseStatus.awaitingApproval');
          break;
        case CaseStatusEnum.APPROVED:
          originatingState = this.translateService.instant('caseManagement.caseStatus.pendingInvestigation');
          break;
        case CaseStatusEnum.OPEN:
          originatingState = this.translateService.instant('caseManagement.caseStatus.outboundRequest');
          break;
        case CaseStatusEnum.COMPLETED:
          originatingState = this.translateService.instant('caseManagement.caseStatus.responseProvided') || 'Response Provided';
          break;
        case CaseStatusEnum.CLOSED:
          originatingState = CaseStatusEnum.CLOSED;
          break;
        case CaseStatusEnum.ARCHIVED:
          originatingState = CaseStatusEnum.ARCHIVED;
          break;
        default:
          originatingState = this.translateService.instant('caseManagement.caseStatus.unknown');
      }

      return truncate ? this.truncateString(originatingState, 10) : originatingState;
    } else if (userFiuId === assignedFIU) {
      switch (currentStatus) {
        case CaseStatusEnum.DRAFT:
          assignedState = CaseStatusEnum.DRAFT;
          break;
        case CaseStatusEnum.NEW:
          assignedState = CaseStatusEnum.NEW;
          break;
        case CaseStatusEnum.APPROVED:
          assignedState = this.translateService.instant('caseManagement.caseStatus.newRequest');
          break;
        case CaseStatusEnum.OPEN:
          assignedState = this.translateService.instant('caseManagement.caseStatus.openRequest');
          break;
        case CaseStatusEnum.COMPLETED:
          assignedState = this.translateService.instant('caseManagement.caseStatus.responseSubmitted') || 'Response Submitted';
          break;
        case CaseStatusEnum.CLOSED:
          assignedState = CaseStatusEnum.COMPLETED;
          break;
        case CaseStatusEnum.ARCHIVED:
          assignedState = CaseStatusEnum.ARCHIVED;
          break;
        default:
          assignedState = this.translateService.instant('caseManagement.caseStatus.unknown');
      }
      return truncate ? this.truncateString(assignedState, 10) : assignedState;
    }

    return currentStatus;
  }

  truncateString(str: string, length: number): string {
    if (str.length > length) {
      return str.substring(0, length) + '...';
    } else {
      return str;
    }
  }
}
